import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

export interface IPhoneProps {
  phone: string;
  siteBlockId?: number | null;
}

export function SinglePhoneComponent(props: IPhoneProps) {
  return <UIHeading2>{props.phone}</UIHeading2>;
}
